import { Loader2 } from 'lucide-react'

interface LoadingOverlayProps {
  visible?: boolean
}

export function LoadingOverlay({ visible = false }: LoadingOverlayProps) {
  if (!visible) return null

  return (
    <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
      <div className="flex flex-col items-center gap-3 px-6 py-5 rounded-2xl bg-foreground/60 dark:bg-background/60 backdrop-blur-md border border-white/10 shadow-2xl">
        <Loader2 className="w-7 h-7 text-white dark:text-foreground animate-spin" />
        <span className="text-xs font-medium text-white/80 dark:text-foreground/80">loading...</span>
      </div>
    </div>
  )
}
